"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("@/components/upload"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'userInfo',
  components: {
    upload: _upload.default
  },
  data: function data() {
    return {
      userInfo: {},
      userForm: {},
      fileList: []
    };
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/my_user_info').then(function (res) {
        _this.userInfo = res;
        _this.userForm = res;
        _this.fileList = [{
          url: res.avatar
        }];
      });
    },
    /**
     * 修改用户信息
     */
    editUser: function editUser() {
      var _this2 = this;
      this.userForm.user_name = this.userForm.phone;
      this.$post('agentapi/save_my_info', this.userForm).then(function (res) {
        _this2.$message({
          message: '修改成功',
          type: 'success'
        });
        // setTimeout(()=>{
        //   location.reload()
        // }, 1000)
      });
    },
    /**www
     * 上传文件成功通知
     */
    fileOk: function fileOk(arr) {
      this.userForm.avatar = arr[0] || '';
    }
  }
};